import postalCodes from 'postal-codes-js';

const validateZipcode = (zipCode, marketIso) => {
  const isValid = postalCodes.validate(marketIso, zipCode);

  if (isValid === true) {
    return isValid;
  }

  return false;
};

export default validateZipcode;